export enum TicketSending {
    Regular = "REGULAR",
    Longer = "LONGER",
}
